{
	"description": "Notre équipe a déjà été informée de l'erreur. Veuillez actualiser la page et réessayer.",
	"descriptionWithError": "Si le problème est récurrent, communiquez à notre équipe le code ci-dessus.",
	"subtitle": "Code erreur",
	"title": "Quelque chose n'a pas fonctionné"
}
